module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/home-category-185-bb276c.svg";